<script>
  import Section from '../components/Section.svelte';
  import Panel from '../components/Panel.svelte';
  import Alert from '../components/Alert.svelte';
  import HelpDrawer from '../components/HelpDrawer.svelte';
  import { signIn, role, institution } from '../lib/role.svelte.js';
  import { ROLES } from '../../shared/config.js';
  import { HELP } from '../lib/help.js';

  const roleList = Object.values(ROLES);
</script>

<HelpDrawer {...HELP.login} />

<h1 class="wf2-title wf2-title-level-1">Sign in</h1>

<Section title="Choose your role">
  <Panel>
    <p class="wf2-text">{institution().name}{#if institution().tagline} — {institution().tagline}{/if}</p>
    <p class="wf2-caption">
      Pick the role that matches your work. You are not signing in as a Solid
      identity — your institution has one WebID, held by the backend, that
      partners grant access to. Your role decides which screens you see and what
      you may do.
    </p>

    <div class="role-grid">
      {#each roleList as r}
        <button class="role-card" onclick={() => signIn(r.id)}>
          <span class="role-name">{r.label}</span>
          <span class="wf2-caption">{r.blurb}</span>
        </button>
      {/each}
    </div>

    {#if role.error}
      <Alert title="Backend unreachable" variant="danger">
        <p class="mono">{role.error}</p>
        <p class="wf2-text">
          The app backend holds this institution's credential and does all Pod
          access. Start it with <code class="mono">npm run dev</code> (which runs
          the API and Vite together), and make sure the Phase A Pod is up
          (<code class="mono">../demo_scripts/demo_up.sh --pilot ctl</code>).
        </p>
      </Alert>
    {:else if role.health}
      <Alert title="Backend connected" variant="info">
        <p class="wf2-text">
          Acting as <code class="mono">{role.health.actingAs}</code> via held
          client credentials. No token ever reaches this browser.
        </p>
      </Alert>
    {/if}
  </Panel>
</Section>

<style>
  .role-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: var(--space-2);
    margin: var(--space-3) 0;
  }
  .role-card {
    display: flex;
    flex-direction: column;
    gap: 6px;
    text-align: left;
    padding: var(--space-3);
    border: 1px solid var(--line, #ddd);
    border-radius: 8px;
    background: transparent;
    cursor: pointer;
    font: inherit;
  }
  .role-card:hover {
    border-color: var(--accent);
    background: color-mix(in srgb, var(--accent) 6%, transparent);
  }
  .role-name { font-weight: 600; }
</style>
